import { render, staticRenderFns } from "./AddonProgrammeFeeReport.vue?vue&type=template&id=e25ae936&scoped=true"
import script from "./AddonProgrammeFeeReport.vue?vue&type=script&lang=js"
export * from "./AddonProgrammeFeeReport.vue?vue&type=script&lang=js"
import style0 from "./AddonProgrammeFeeReport.vue?vue&type=style&index=0&id=e25ae936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25ae936",
  null
  
)

export default component.exports